/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ProductByBarcodeInventoryItemFragment = { itemId: string, quantity?: number | null, orderType: Types.OrderType, availableFromDateUtc: string, availableToDateUtc: string, inventoryId: string };

export type ProductAttributesFragment = { productId: string, displayedProductId?: string | null, title: string, color?: string | null, colorCode?: string | null, parentId?: string | null, brandId: string, mainImageUrl?: string | null, isLocked?: boolean | null, attributes: any, earliestDeliveryDate?: string | null, isNew?: boolean | null, canBeSold?: boolean | null, canBeMarketed?: boolean | null, media: Array<{ url: string, type: Types.MediaType }>, priceRanges: Array<{ markup?: number | null, currency?: string | null, rrp?: { max?: number | null, min?: number | null } | null, wsp?: { max?: number | null, min?: number | null } | null, discount?: { max?: number | null, min?: number | null } | null }>, relatedVariants?: Array<{ title: string, productId: string, mainImageUrl?: string | null, media: Array<{ url: string, type: Types.MediaType }> }> | null, children?: Array<{ media: Array<{ url: string, type: Types.MediaType }> }> | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null, inventoryItems?: Array<{ availableToDateUtc: string, availableFromDateUtc: string, orderType: Types.OrderType, inventoryId: string }> | null };

export type ProductByBarcodeQueryVariables = Types.Exact<{
  productBarcode: Types.Scalars['String']['input'];
}>;


export type ProductByBarcodeQuery = { productByBarcode?: { isAvailable?: boolean | null, productId: string, displayedProductId?: string | null, title: string, color?: string | null, colorCode?: string | null, parentId?: string | null, brandId: string, mainImageUrl?: string | null, isLocked?: boolean | null, attributes: any, earliestDeliveryDate?: string | null, isNew?: boolean | null, canBeSold?: boolean | null, canBeMarketed?: boolean | null, parent?: { productId: string, displayedProductId?: string | null, title: string, color?: string | null, colorCode?: string | null, parentId?: string | null, brandId: string, mainImageUrl?: string | null, isLocked?: boolean | null, attributes: any, earliestDeliveryDate?: string | null, isNew?: boolean | null, canBeSold?: boolean | null, canBeMarketed?: boolean | null, parent?: { productId: string, displayedProductId?: string | null, title: string, color?: string | null, colorCode?: string | null, parentId?: string | null, brandId: string, mainImageUrl?: string | null, isLocked?: boolean | null, attributes: any, earliestDeliveryDate?: string | null, isNew?: boolean | null, canBeSold?: boolean | null, canBeMarketed?: boolean | null, media: Array<{ url: string, type: Types.MediaType }>, priceRanges: Array<{ markup?: number | null, currency?: string | null, rrp?: { max?: number | null, min?: number | null } | null, wsp?: { max?: number | null, min?: number | null } | null, discount?: { max?: number | null, min?: number | null } | null }>, relatedVariants?: Array<{ title: string, productId: string, mainImageUrl?: string | null, media: Array<{ url: string, type: Types.MediaType }> }> | null, children?: Array<{ media: Array<{ url: string, type: Types.MediaType }> }> | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null, inventoryItems?: Array<{ availableToDateUtc: string, availableFromDateUtc: string, orderType: Types.OrderType, inventoryId: string }> | null } | null, media: Array<{ url: string, type: Types.MediaType }>, priceRanges: Array<{ markup?: number | null, currency?: string | null, rrp?: { max?: number | null, min?: number | null } | null, wsp?: { max?: number | null, min?: number | null } | null, discount?: { max?: number | null, min?: number | null } | null }>, relatedVariants?: Array<{ title: string, productId: string, mainImageUrl?: string | null, media: Array<{ url: string, type: Types.MediaType }> }> | null, children?: Array<{ media: Array<{ url: string, type: Types.MediaType }> }> | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null, inventoryItems?: Array<{ availableToDateUtc: string, availableFromDateUtc: string, orderType: Types.OrderType, inventoryId: string }> | null } | null, media: Array<{ url: string, type: Types.MediaType }>, priceRanges: Array<{ markup?: number | null, currency?: string | null, rrp?: { max?: number | null, min?: number | null } | null, wsp?: { max?: number | null, min?: number | null } | null, discount?: { max?: number | null, min?: number | null } | null }>, relatedVariants?: Array<{ title: string, productId: string, mainImageUrl?: string | null, media: Array<{ url: string, type: Types.MediaType }> }> | null, children?: Array<{ media: Array<{ url: string, type: Types.MediaType }> }> | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null, inventoryItems?: Array<{ availableToDateUtc: string, availableFromDateUtc: string, orderType: Types.OrderType, inventoryId: string }> | null } | null };

export type ProductsByBarcodesQueryVariables = Types.Exact<{
  barcodes: Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ProductsByBarcodesQuery = { productsByBarcodes: Array<{ id: string, product?: { productId: string, brandId: string } | null } | null> };

export const ProductByBarcodeInventoryItemFragmentDoc = gql`
    fragment ProductByBarcodeInventoryItem on InventoryItem {
  itemId
  quantity
  orderType
  availableFromDateUtc
  availableToDateUtc
  inventoryId
}
    `;
export const ProductAttributesFragmentDoc = gql`
    fragment ProductAttributes on Product {
  productId
  displayedProductId
  title
  color
  colorCode
  parentId
  brandId
  mainImageUrl
  isLocked
  media {
    url
    type
  }
  priceRanges {
    rrp {
      max
      min
    }
    wsp {
      max
      min
    }
    markup
    discount {
      max
      min
    }
    currency
  }
  relatedVariants {
    title
    productId
    mainImageUrl
    media {
      url
      type
    }
  }
  children {
    media {
      url
      type
    }
  }
  icons {
    hasSustainableChoiceIcon
    hasPopularityIcon
    hasGlobalNoosIcon
    marketingSupportEolDate
    hasMarketingSupportIcon
    hasNewIconByDeliveryMonth
  }
  attributes
  earliestDeliveryDate
  isNew
  canBeSold
  canBeMarketed
  inventoryItems {
    availableToDateUtc
    availableFromDateUtc
    orderType
    inventoryId
  }
}
    `;
export const ProductByBarcodeDocument = gql`
    query ProductByBarcode($productBarcode: String!) {
  productByBarcode(productBarcode: $productBarcode) {
    isAvailable
    ...ProductAttributes
    parent {
      ...ProductAttributes
      parent {
        ...ProductAttributes
      }
    }
  }
}
    ${ProductAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductByBarcodeGQL extends Apollo.Query<ProductByBarcodeQuery, ProductByBarcodeQueryVariables> {
    document = ProductByBarcodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductsByBarcodesDocument = gql`
    query ProductsByBarcodes($barcodes: [String]!) {
  productsByBarcodes(barcodes: $barcodes) {
    id
    product {
      productId
      brandId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductsByBarcodesGQL extends Apollo.Query<ProductsByBarcodesQuery, ProductsByBarcodesQueryVariables> {
    document = ProductsByBarcodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }